import React from "react";
import TitleText from "app/containers/Auth/components/TitleText";
import useCreateProfile from "./hooks/useCreateProfile";
import ProfileFields from "./components/ProfileFields";
import Button from "app/components/Button";

export default function Index() {
  const {
    handleSubmit,
    isDisabled,
    isLoading,
    isGoogleLogin,
    name,
    password,
    confirmPassword,
    timezone,
    handleChange,
    handleSelect
  } = useCreateProfile();

  return (
    <div className="flex flex-col items-center">
      <TitleText title="Create a profile" />
      <div className="flex flex-col gap-[20px] min-w-[440px] mb-[56px]">
        <ProfileFields
          //@ts-ignore
          isGoogleLogin={isGoogleLogin}
          name={name}
          password={password}
          confirmPassword={confirmPassword}
          timezone={timezone}
          isLoading={isLoading}
          handleChange={handleChange}
          handleSelect={handleSelect}
        />
        <Button
          className="w-full h-[56px] mt-2"
          onClick={handleSubmit}
          isLoading={isLoading}
          disabled={isLoading || isDisabled()}
        >
          Create profile
        </Button>
      </div>
    </div>
  );
}
